import React from 'react'

import { SectionHeaderContainer, SectionHeaderContainerProps } from './styled'

export type { SectionHeaderContainerProps } from './styled'

export interface SectionHeaderProps extends SectionHeaderContainerProps {
    /**
     * Section Header
     */
    label: string
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
    color = '#131313',
    label,
    ...props
}) => {
    const hideSectionHeader = label === "" ? {display: "none"} : { display: "inline-block"}

    return (
        <SectionHeaderContainer color={color} style={hideSectionHeader}>
            <h3>{label}</h3>
        </SectionHeaderContainer>
    )
}
